import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { doGetPromise } from '../../core/config/core.httpclient-utils';
@Injectable()
export class ForumService {

    constructor(private http: HttpClient) {
        this.http = http;
    }

    fetch(params: any = {}) {
        return doGetPromise(this.http, '/api/forum', params);
    }

    forumSummary(forumId: number = 0) {
        return doGetPromise(this.http, `/api/forum/${forumId}?rel=threadParentCount`);
    }

    threadMessages(threadId: number = 0, parentForumMessageId: number = 0, params: any = {}) {

        const std = {
            forumThread: threadId,
            rel: 'childcount,attachments',
            parentForumMessageId: parentForumMessageId
        };
        const p = Object.assign(std, params);

        return doGetPromise(this.http, 'api/forummessage', p);
    }

    postMessage(messageId: number = 0, data: any = {}) {
        return this.http.post(`/api/forummessage/${messageId}`, data)
        .toPromise()
    }

    deleteMessage(messageId: number = 0) {
        return this.http.delete(`api/forummessage/${messageId}`)
        .toPromise()
    }

    postForum(forumId: number = 0, data: any = {}) {
        return this.http.post(`/api/forum/${forumId}`, data)
        .toPromise()
    }

    deleteForum(forumId: number = 0) {
        return this.http.delete(`api/forum/${forumId}`)
        .toPromise()
    }
    
    postThread(forumId: number = 0, threadId: number = 0, data: any = {}) {
        return this.http.post(`/api/forum/${forumId}/thread/${threadId}`, data)
        .toPromise()
    }
    
    deleteThread(threadId: number = 0) {
        return this.http.delete(`/api/forum/0/thread/${threadId}`)
        .toPromise()
    }
    
    getMonitor(params: any = {}) {
        return doGetPromise(this.http, '/api/monitor?section=forum', params);
    }
}
